import React, {lazy, useEffect, useState} from "react";
import styled from "styled-components";
import Input from "../../components/Input";
import {XButton} from "../../components/Button";
// import PriceChart from "./price-chart";
import {useVipInfo} from "../../context/VipInfoContext";
import {formatUnits} from "ethers/lib/utils";
// import {useContract} from "../../hooks/useContract";
// import {ADDRESS_COCOSTOKEN, ADDRESS_COCOSVIPBOOK} from "../../utils/constant";
// import {ABI_COCOS_VIP} from "../../utils/abis";
// import {DialogType, useDialog} from "../../context/DialogContext";
// import {getReferCode} from "../../utils";
// import useApproved from "../../hooks/useApproved";
// import {useBalance} from "../../hooks/useBalance";

const PriceChart = lazy(() => import(/*webpackPrefetch:true*/'./price-chart'))

export default function BuyMember() {
    const [name, setName] = useState('')
    const info = useVipInfo()
    // const contract = useContract(ADDRESS_COCOSVIPBOOK, ABI_COCOS_VIP)
    // const {open} = useDialog()
    // const {approved, approve} = useApproved(ADDRESS_COCOSTOKEN, ADDRESS_COCOSVIPBOOK)
    const [error, setError] = useState('')
    // const balance = useBalance(ADDRESS_COCOSTOKEN)
    useEffect(() => {
        setError('')
    }, [name])
    // const handleBuy = useCallback(async () => {
    //     if (!info.isWhiteList && info.maxRegisterCount === info.soldRegisterCount) {
    //         open(DialogType.Error, {title: 'Purchase error!', desc: 'The first 5000 membership quotas have been sold out, please wait for the opening time of the membership quotas in the next issue'})
    //         return
    //     }
    //     if (/^\d+$/.test(name) || !/^[\da-zA-Z]+$/.test(name)) {
    //         setError('Invalid username. Please refer to username requirements')
    //         return
    //     }
    //     if (name.length < 6 || name.length > 32) {
    //         setError('Invalid username. Please refer to username requirements')
    //         return
    //     }
    //     if (name.toLowerCase().startsWith('0x')) {
    //         setError('Your username cannot start with 0x')
    //         return
    //     }

    //     if (!approved && !info.isWhiteList) {
    //         // open(DialogType.Waiting, {title: 'Waiting for approve.'})
    //         if (!await approve()) {
    //             return
    //         }
    //     }
    //     if (!info.isWhiteList && balance.lt(info.registerFee)) {
    //         open(DialogType.Error, {desc: 'COCOS Token quantity: insufficient wallet balance'})
    //         return
    //     }
    //     if (contract) {
    //         open(DialogType.Waiting, {title: 'Waiting for confirmation.'})
    //         try {
    //             const res = await contract.registerNameXName(name, getReferCode())
    //             await res.wait()
    //             open(DialogType.Success)
    //         } catch (e:any) {
    //             open(DialogType.Error, {desc: e?.data?.message || e?.message || 'unknown error'})
    //         }
    //     }
    // }, [contract, name, approved, approve, open, balance, info])
    return <BuyWrapper>
        <BuyCard>
            <BuyTips>The price will rise automatically by 2 COCOS each time 100 memberships are sold</BuyTips>
            <DataWrapper>
                <span className={'left'}>
                    Current price: <span className={'highlight'}>{info.isWhiteList ? 0 : +formatUnits(info.registerFee)} COCOS</span>
                </span>
                <span className={'right'}>
                    Remaining places: <span className={"highlight"}>{info.maxRegisterCount - info.soldRegisterCount}</span>
                </span>
            </DataWrapper>
            {/*Invalid username. Please refer to username requirements*/}
            <FormWrapper>
                <Input placeholder={'Please enter your name'} value={name} onChange={setName}/>
                <ErrorTips>{error}</ErrorTips>
                <BuyButton onClick={() => {
                  return
                  // handleBuy()
                }}>Membership sold out. Stay tuned!</BuyButton>
                <NameRule>The name must be unique/numbers+letters/6~32characters/cannot start with 0x</NameRule>
            </FormWrapper>
        </BuyCard>
        <PriceChart/>
    </BuyWrapper>
}

const BuyWrapper = styled.div`
  width: 1150px;
  height: 464px;
  background: #11388C;
  border-radius: 23px;
  padding: 47px 45px 0 45px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 30px;
`

const BuyCard = styled.div`
  width: 495px;
  height: 370px;
  background: linear-gradient(136deg, #2D5FCE 0%, #224BA4 100%);
  border-radius: 23px;
  padding: 37px 59px;
`
const BuyTips = styled.p`
  color: #FFF;
  line-height: 26px;
  font-weight: bold;
  max-width: 340px;
`

const DataWrapper = styled.div`
  height: 19px;
  line-height: 19px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;

  span.highlight {
    color: #FFD244;
  }

  span.left {
    font-size: 16px;
    color: #FFF;
  }

  span.right {
    font-size: 14px;
    color: #FFFFFF;
  }
`

const FormWrapper = styled.div`
  margin-top: 18px;
`

const BuyButton = styled(XButton)`
  width: 377px;
  height: 45px;
  color: #624B00;
  margin-top: 21px;

  background: #C6CDCC;
  color: #FFF;
`

const ErrorTips = styled.p`
  color: #FF0000;
  font-size: 14px;
  line-height: 14px;
  margin-top: 10px;
`

const NameRule = styled.p`
  font-size: 14px;
  color: #6090F8;
  line-height: 19px;
  margin-top: 18px;
`